import { Button, Flex, Typography } from "antd";
import { SummaryButton, SummaryTitle } from "./styled";
import { useIntl } from "react-intl";
import { useContext } from "react";
import { useApp } from "contexts/AppProvider";
import { LanguageContext } from "contexts/LangProvider";
import { content } from "i18n/content";

export const Summary = ({ activeService, activeCity, setIsHidden }) => {
  const { reservationPayload } = useApp();
  const { locale } = useContext(LanguageContext);
  const { formatMessage } = useIntl();

  const getOptionName = () => {
    return activeService.options.find((el) => el.id === reservationPayload.visitTypeId)?.translations[locale];
  };

  const getTherapistName = () => {
    if (reservationPayload.therapist) {
      return reservationPayload.therapist;
    }
    return formatMessage({ defaultMessage: "Dowolny specjalista", id: "PpkeBx" });
  };

  return (
    <Flex wrap justify="space-between" align="flex-end">
      <div>
        <SummaryTitle>{formatMessage({ defaultMessage: "Twoja wizyta", id: "SZLLwD" })}</SummaryTitle>
        <Flex wrap>
          <div style={{ width: "80px" }}>
            <Typography.Text>{formatMessage({ defaultMessage: "Lokalizacja", id: "VAnOby" })}:</Typography.Text>
          </div>
          <div>
            <Typography.Text strong>{activeCity}</Typography.Text>
          </div>
        </Flex>
        <Flex wrap>
          <div style={{ width: "80px" }}>
            <Typography.Text>{formatMessage({ defaultMessage: "Typ wizyty", id: "fZQn0m" })}:</Typography.Text>
          </div>
          <div>
            <Typography.Text strong>{activeService.translations[locale]} </Typography.Text>
            <Typography.Text>({getOptionName()})</Typography.Text>
          </div>
        </Flex>
        <Flex>
          <div style={{ width: "80px" }}>
            <Typography.Text>{formatMessage({ defaultMessage: "Specjalista", id: "dz8aKC" })}:</Typography.Text>
          </div>
          <div>
            <Typography.Text strong>{getTherapistName()}</Typography.Text>
          </div>
        </Flex>
      </div>
      <SummaryButton>
        <Button type="default" onClick={() => setIsHidden(false)}>
          {formatMessage({ defaultMessage: "Zmień", id: "OH4sDW" })}
        </Button>
      </SummaryButton>
    </Flex>
  );
};
